<div class="objectives-content__others">
  <div class="title-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.75 4.75C10.75 4.2061 10.5887 3.67442 10.2865 3.22218C9.98437 2.76995 9.55488 2.41747 9.05238 2.20933C8.54988 2.00119 7.99695 1.94673 7.4635 2.05284C6.93006 2.15895 6.44005 2.42086 6.05546 2.80546C5.67086 3.19005 5.40895 3.68005 5.30284 4.2135C5.19673 4.74695 5.25119 5.29988 5.45933 5.80238C5.66747 6.30488 6.01995 6.73437 6.47218 7.03654C6.92442 7.33872 7.4561 7.5 8 7.5C8.72909 7.49917 9.42809 7.20918 9.94363 6.69363C10.4592 6.17809 10.7492 5.47909 10.75 4.75ZM8 6.5C7.65388 6.5 7.31554 6.39737 7.02775 6.20507C6.73997 6.01278 6.51567 5.73947 6.38321 5.4197C6.25076 5.09993 6.2161 4.74806 6.28363 4.40859C6.35115 4.06913 6.51782 3.75731 6.76256 3.51256C7.00731 3.26782 7.31913 3.10115 7.65859 3.03363C7.99806 2.9661 8.34993 3.00076 8.6697 3.13321C8.98947 3.26567 9.26278 3.48997 9.45507 3.77775C9.64737 4.06554 9.75 4.40388 9.75 4.75C9.75 5.21413 9.56563 5.65925 9.23744 5.98744C8.90925 6.31563 8.46413 6.5 8 6.5ZM11.75 8C11.2061 8 10.6744 8.16129 10.2222 8.46346C9.76995 8.76563 9.41747 9.19513 9.20933 9.69762C9.00119 10.2001 8.94673 10.7531 9.05284 11.2865C9.15895 11.8199 9.42086 12.31 9.80546 12.6945C10.1901 13.0791 10.6801 13.3411 11.2135 13.4472C11.747 13.5533 12.2999 13.4988 12.8024 13.2907C13.3049 13.0825 13.7344 12.7301 14.0365 12.2778C14.3387 11.8256 14.5 11.2939 14.5 10.75C14.4992 10.0209 14.2092 9.32192 13.6936 8.80637C13.1781 8.29083 12.4791 8.00083 11.75 8ZM11.75 12.5C11.4039 12.5 11.0655 12.3974 10.7778 12.2051C10.49 12.0128 10.2657 11.7395 10.1332 11.4197C10.0008 11.0999 9.9661 10.7481 10.0336 10.4086C10.1012 10.0691 10.2678 9.75731 10.5126 9.51256C10.7573 9.26782 11.0691 9.10115 11.4086 9.03363C11.7481 8.9661 12.0999 9.00076 12.4197 9.13321C12.7395 9.26567 13.0128 9.48997 13.2051 9.77775C13.3974 10.0655 13.5 10.4039 13.5 10.75C13.5 11.2141 13.3156 11.6592 12.9874 11.9874C12.6592 12.3156 12.2141 12.5 11.75 12.5ZM4.25 8C3.7061 8 3.17442 8.16129 2.72218 8.46346C2.26995 8.76563 1.91747 9.19513 1.70933 9.69762C1.50119 10.2001 1.44673 10.7531 1.55284 11.2865C1.65895 11.8199 1.92086 12.31 2.30546 12.6945C2.69005 13.0791 3.18006 13.3411 3.7135 13.4472C4.24695 13.5533 4.79988 13.4988 5.30238 13.2907C5.80488 13.0825 6.23437 12.7301 6.53654 12.2778C6.83872 11.8256 7 11.2939 7 10.75C6.99917 10.0209 6.70918 9.32192 6.19363 8.80637C5.67809 8.29083 4.97909 8.00083 4.25 8ZM4.25 12.5C3.90388 12.5 3.56554 12.3974 3.27775 12.2051C2.98997 12.0128 2.76567 11.7395 2.63321 11.4197C2.50076 11.0999 2.4661 10.7481 2.53363 10.4086C2.60115 10.0691 2.76782 9.75731 3.01256 9.51256C3.25731 9.26782 3.56913 9.10115 3.90859 9.03363C4.24806 8.9661 4.59993 9.00076 4.9197 9.13321C5.23947 9.26567 5.51278 9.48997 5.70507 9.77775C5.89737 10.0655 6 10.4039 6 10.75C6 11.2141 5.81563 11.6592 5.48744 11.9874C5.15925 12.3156 4.71413 12.5 4.25 12.5Z"
        fill="#6B7680"
      />
    </svg>
    <h2 class="heading-h2">Outros</h2>
  </div>

  <div class="objective-name">
    <h3 class="heading-h3">Nome do objetivo</h3>
    <p>{{ dataStoreOthers.objectiveName }}</p>
  </div>

  <div class="others-reason">
    <h3 class="heading-h3">Por que escolheu esse objetivo?</h3>
    <p>
      {{ dataStoreOthers.description }}
    </p>

    <h3 class="heading-h3">Quando deseja realizar esse objetivo?</h3>
    <p>{{ intendDate }}</p>
  </div>

  <div class="others-reason">
    <h3 class="heading-h3">Quanto pretende investir nesse objetivo?</h3>
    <div class="pretend-invest-container">
      <div class="invest__min">
        <h4 class="heading-h4">Minimo</h4>
        <p>{{ minInvestimentFormated }} /mês</p>
      </div>
      <div class="invest__max">
        <h4 class="heading-h4">Maximo</h4>
        <p>{{ maxInvestimentFormated }} /mês</p>
      </div>
    </div>
    <div>
      <h3 class="heading-h3">Observações</h3>
      <p>
        {{ dataStoreOthers.observation }}
      </p>
    </div>
  </div>
</div>
